//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Cpts020 from '@/components/lyx-components/cpts020/index.vue'

    export default {
        components: {
            Cpts020
        },
        data() {
            return {
                minHeight: "",
                cityData: '',
                partCity: []
            };
        },
        mounted() {
            this.minHeight = document.documentElement.clientHeight;

            document.title = '选择地区'

            this.$http.get('/static/json/lyx/cityData.json').then((response) => {
                this.$set(this, 'cityData', response.data)
            }).then(() => {
                this.cityData.map(item => {
                    switch(item.cityId){
                        case "630100":
                            this.partCity.push(item)
                            break;
                        case "630200":
                            this.partCity.push(item)
                            break;
                        case "632200":
                            this.partCity.push(item)
                            break;
                        case "632800":
                            this.partCity.push(item)
                            break;
                        case "632500":
                            this.partCity.push(item)
                            break;
                        case "632300":
                            this.partCity.push(item)
                            break;
                        case "632700":
                            this.partCity.push(item)
                            break;
                        case "632600":
                            this.partCity.push(item)
                            break;
                    }
                })
            })
        }
    };
